import { render, staticRenderFns } from "./ZDTextarea.vue?vue&type=template&id=35acd7ca&"
import script from "./ZDTextarea.vue?vue&type=script&lang=js&"
export * from "./ZDTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports